import { useQuery } from 'react-query';
import { Metadata } from './types';
import MetadataService from '../../Api/meta-data-service';

export const useGetMetaData = <T = unknown>(key: string) =>
  useQuery<Metadata<T>>(['metadata-service-meta-data', key], () =>
    MetadataService.getMetaData(key),
  );
